import "./Home.css";
import { Link } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Image from "react-bootstrap/Image";
import Button from "react-bootstrap/Button";
import Carousel from "react-bootstrap/Carousel";

function Galabau() {
  return (
    <div className="hero-container">
      <Container className="py-3">
        {/* Hero Section */}
        <Row className="align-items-center py-5">
          <Col xs={12} md={6} className="text-center text-md-start">
            <h1 className="fs-1 text-white">
              Garten und Landschaftsbau wir setzen ihre Vorstellungen um.
            </h1>
            <p className="text-break text-wrap mt-4 text-white fs-6 fs-md-5 fs-lg-4">
              Erdbewegungen aller Art sind mit unseren kleinen Helfern ein
              Kinderspiel. Mit unserem Minibagger und Miniradlader verwandeln
              wir Ihren Garten in die Wohlfühloase, die Sie sich verdient haben.
              Nach dem Bagger kommt die Fräse und nach der Fräse die Saat mit
              Walze. Gerne legen wir Ihren Garten mit verschiedenen hochwertigen
              Rasenmischungen oder Hecken- und Sträuchern an, um eine Vielzahl
              an Nützlingen in Ihrem Garten anzusiedeln. Aber auch Zäune und
              gepflasterte Flächen dürfen in einem Garten nicht fehlen. Wir
              bieten Ihnen eine Vielzahl an Möglichkeiten, um Ihren Garten zu
              verschönern.
            </p>
          </Col>
          <Col
            xs={12}
            md={6}
            className="d-flex justify-content-center mt-4 mt-md-0"
          >
            <Carousel>
              <Carousel.Item>
                <Image src="http://picsum.photos/1200/800" fluid />;
                <Carousel.Caption>
                  <h3>First slide label</h3>
                  <p>
                    Nulla vitae elit libero, a pharetra augue mollis interdum.
                  </p>
                </Carousel.Caption>
              </Carousel.Item>
              <Carousel.Item>
                <Image src="http://picsum.photos/1200/800" fluid />;
                <Carousel.Caption>
                  <h3>Second slide label</h3>
                  <p>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  </p>
                </Carousel.Caption>
              </Carousel.Item>
              <Carousel.Item>
                <Image src="http://picsum.photos/1200/800" fluid />;
                <Carousel.Caption>
                  <h3>Third slide label</h3>
                  <p>
                    Praesent commodo cursus magna, vel scelerisque nisl
                    consectetur.
                  </p>
                </Carousel.Caption>
              </Carousel.Item>
            </Carousel>
          </Col>
        </Row>

        <Row className="align-items-center py-5">
          {/* Text soll auf kleinen Bildschirmen unten erscheinen */}
          <Col
            xs={{ span: 12, order: 1 }}
            md={{ span: 6, order: 2}}
            className="text-center text-md-start"
          >
            <p className="text-break text-wrap mt-4 text-white fs-6 fs-md-5 fs-lg-4">
              Kontaktieren Sie uns gerne unverbindlich. In einem ersten
              Telefonat besprechen wir Ihr Vorhaben und vereinbaren einen Termin
              vor Ort. Wir freuen uns auf Sie.
            </p>
            <Button
              as={Link}
              to="/kontakt"
              variant="outline-light"
              className="btn-lg"
            >
              Kontakt
            </Button>
          </Col>

          {/* Carousel soll auf kleinen Bildschirmen oben erscheinen */}
          <Col
            xs={{ span: 12, order: 2 }}
            md={{ span: 6, order: 1 }}
            className="d-flex justify-content-center mt-4 mt-md-0"
          >
            <Carousel>
              <Carousel.Item>
                <Image src="http://picsum.photos/1200/800" fluid />
                <Carousel.Caption>
                  <h3>First slide label</h3>
                  <p>
                    Nulla vitae elit libero, a pharetra augue mollis interdum.
                  </p>
                </Carousel.Caption>
              </Carousel.Item>
              <Carousel.Item>
                <Image src="http://picsum.photos/1200/800" fluid />
                <Carousel.Caption>
                  <h3>Second slide label</h3>
                  <p>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  </p>
                </Carousel.Caption>
              </Carousel.Item>
              <Carousel.Item>
                <Image src="http://picsum.photos/1200/800" fluid />
                <Carousel.Caption>
                  <h3>Third slide label</h3>
                  <p>
                    Praesent commodo cursus magna, vel scelerisque nisl
                    consectetur.
                  </p>
                </Carousel.Caption>
              </Carousel.Item>
            </Carousel>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Galabau;
